import { render, staticRenderFns } from "./AssistProductBenefitTitle.vue?vue&type=template&id=7a09191e&scoped=true"
import script from "./AssistProductBenefitTitle.vue?vue&type=script&lang=js"
export * from "./AssistProductBenefitTitle.vue?vue&type=script&lang=js"
import style0 from "./AssistProductBenefitTitle.vue?vue&type=style&index=0&id=7a09191e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a09191e",
  null
  
)

export default component.exports